import type { AgencyContactPatch } from '@/models/agency-contact'

// Pure data shape for the wizard's profile write-backs — kept free of
// service imports so pure modules (classify.ts) and their tests can use
// it. The I/O lives in profile-writeback.ts.

export interface WriteBackIntents {
  /** Fields to set on the agency's saved contact (per-field patch). */
  agencyContact: AgencyContactPatch
  /** Fields to set on the current user's recruiter profile. */
  recruiter: Partial<Record<'name' | 'phone' | 'email' | 'linkedIn', string>>
}

export function emptyWriteBacks(): WriteBackIntents {
  return { agencyContact: {}, recruiter: {} }
}

export function hasWriteBacks(intents: WriteBackIntents): boolean {
  return (
    Object.keys(intents.agencyContact).length > 0 ||
    Object.keys(intents.recruiter).length > 0
  )
}
